export default __webpack_public_path__ + "static/media/level_g_icon.0405a4d5.png";